// The move library (WS-49 T4, build contract section 5): how the camera travels to a tour stop and what it does
// while the tour stays there. Every move has the same signature:
//
//   move(options, rig) -> { travel, hold, step(dt, t, len) }
//     options  the stop's `moveOptions`: opaque to the tour engine, each move reads its own
//     rig      the shared camera rig (rig.js)
//     travel   seconds the flight to the stop takes (0 = a cut); null = the engine's own place flight, as on main
//     hold     true = the stay is counted from the start of the flight (main's timing)
//     step     one frame of the stay: `dt` seconds, `t` seconds since arrival, `len` the length of the stay
//
// The tour engine (tours.js) flies; a move only says how long the flight takes and moves the camera during the
// stay. It is called once per stop, so it may keep state between frames. With reduced motion the tour cuts to the
// stop and `step` is not called.
// A new move is one new file in this folder and its line in MOVES.
// Every move turns round the rig's pivot (`rig.around`), which the tour engine sets for each stop from
// `moveOptions.around` (`{ place }` or `{ point: [x, y, z] }`), else the stop's own place, else the target.
// The builder's four (owner 2026-10-31): `still` (Hold), `push-in` (Push in), `fly-orbit` (Circle around), `a-to-b`
// (From A to B). Old names still play: `gentle-drift` as Push in, `sky` (VIS-57's look up at the sky, now the map's
// ordinary look-up: owner 2026-10-31) as Hold at its view.
import flyOrbit from './fly-orbit.js';
import still from './still.js';
import orbit from './orbit.js';
import pushIn from './push-in.js';
import aToB from './a-to-b.js';
import rise from './rise.js';
import lookAround from './look-around.js';

/**
 * @typedef {Object} MovePlan
 * @property {number | null} travel
 * @property {boolean} hold
 * @property {(dt: number, t: number, len: number) => void} step
 */
/** @type {{ [name: string]: (options: object, rig: ReturnType<typeof import('./rig.js').createRig>) => MovePlan }} */
// VIS-265: orbit, rise and look-around are Film's actions at a point, written as poses (rig.js `posed`)
const MOVES = { still, 'push-in': pushIn, 'fly-orbit': flyOrbit, 'a-to-b': aToB, 'gentle-drift': pushIn, sky: still, orbit, rise, 'look-around': lookAround };

/** The move of that name; an unknown name falls back to `fly-orbit`. */
export const moveFor = (name) => (Object.hasOwn(MOVES, name) ? MOVES[name] : flyOrbit);
